module.exports = __webpack_public_path__ + "img/standard.9cdf1aab.svg";